import Vue from 'vue';
import Router from 'vue-router';
import index from '@/components/index';
import vipPage from '@/components/vipPage';
import qiyelist from '@/components/qiyelist';
import details from '@/components/qiyeContent';
import emptyshell from  '@/components/emptyShell';
import company_check from '@/components/company_check';
import ipBackups from '@/components/ipBackups';
import myOrder from '@/components/myOrder';
import about from '@/components/about';
import agreement from '@/components/agreement';
import contactUs from '@/components/contactUs';
import iframeDemo from '@/components/iframeDemo';
import plugin_unit_login from '@/components/plugin_unit_login';
import plugin_unit_index from '@/components/plugin_unit_index';


Vue.use(Router);

export default new Router({
    mode:'history',
	routes: [
		{
			path: '/',
			name: 'index',
			component: index
		},
		{
			path: '/index',
			name: 'index',
			component: index
		},
		{
			path:'/vipMember',
			name:'vipMember',
			component: vipPage
		},
		{
			path:'/wordsList',
			name:'wordsList',
			component: qiyelist
		},
		{
			path:'/details',
			name:'details',
			component: details,
		},
		{
			path:'/emptyshell',
			name:'emptyshell',
			component: emptyshell,
		},
		{
			path:'/company_check',
			name:'company_check',
			component:company_check
		},
		{
			path:'/ipBackups',
			name:'ipBackups',
			component:ipBackups
		},
		{
			path:'/myOrder',
			name:'myOrder',
			component:myOrder
		},
		{
			path:'/about',
			name:'about',
			component:about
		},
		{
			path:'/agreement',
			name:'agreement',
			component:agreement
		},
		{
			path:'/contactUs',
			name:'contactUs',
			component:contactUs
		},
		{
			path:'/iframeDemo',
			name:'iframeDemo',
			component:iframeDemo
		},
		{
			path:'/plugin_unit_login',
			name:'plugin_unit_login',
			component:plugin_unit_login
		},
		{
			path:'/plugin_unit_index',
			name:'plugin_unit_index',
			component:plugin_unit_index
		}
	]
});



// WEBPACK FOOTER //
// ./src/router/index.js